
import * as React from 'react';
import appConfig from 'local_config';
import autobind from 'autobind-decorator';
import { selectAccessory, unselectAccessory } from 'bom/components/utils/partsSelectionFunctions';
import { Checkbox, FormControlLabel } from '@mui/material';
import { SET_NEW_PART_QUANTITY } from 'actions';
import SelectionControl from 'react-md/lib/SelectionControls/SelectionControl';
import { RM_ROOF_PAD, RM_ROOF_PAD_DOMESTIC } from '__common/constants/parts';
import { dispatch } from '__common/store';
import { getLegacyBomControlProps } from 'bom/components/LegacyBomCheckboxIcon';


export default class AccessoryPart extends React.Component<accessoryPartComponentState, {}> {

  @autobind
  toggleAccessory(checked: boolean) {
    const { accessory, accessoriesList, productId, projectId, partsList, continuous_trims_sections , rm_roof_pad, } = this.props;
    if (checked) {
      selectAccessory(accessory, partsList, accessoriesList, continuous_trims_sections, productId, projectId, rm_roof_pad);
    } else {
      unselectAccessory(accessory, partsList, accessoriesList, productId, projectId, continuous_trims_sections, rm_roof_pad);
    }
  }

  render() {
    const { accessory, isSelected, productId, is_rm_roof_pad_checkbox_enable, partsList, legacyCheckboxIcons = false } = this.props;
    const disable = ([RM_ROOF_PAD, RM_ROOF_PAD_DOMESTIC].includes(accessory.number) && is_rm_roof_pad_checkbox_enable) ? true : false;
    const description = productId === 'metal_x' ? accessory.description : accessory.full_description;
    const hasNoImage = !accessory.image || accessory.image.includes('default.jpg') || accessory.number === 'RAYTV3TOOL';
    const selectedPart = partsList.find(part => part.number === accessory.number);
    const selectedQuantity = selectedPart ? selectedPart.quantity : accessory.quantity;

    const updateQuantity = (event: React.ChangeEvent<HTMLInputElement>) => {
      event.stopPropagation();
      const quantity = Number(event.target.value);
      if (Number.isInteger(quantity) && quantity >= 0) {
        dispatch(SET_NEW_PART_QUANTITY(accessory.number, Math.min(quantity, 1000000)));
      }
    };

    return (
      <div 
        className={`accessory accessory-card ${isSelected ? 'accessory-card--selected' : ''} ${disable ? 'accessory-card--disabled' : ''}`}
        onClick={() => !disable && this.toggleAccessory(!isSelected)}
      >
        <div className={`accessory-card__media image ${hasNoImage ? 'accessory-card__media--empty' : ''}`}>
          {!hasNoImage && (
              <img 
                src={`${location.protocol}//${appConfig.apiUrl.slice(0, -1)}${accessory.image}`} 
                alt={accessory.name || 'Accessory'} 
              />
          )}
        </div>

        <div className="accessory-card__heading">
          <div className="accessory-card__name accessory-name">
            {accessory.name}
          </div>
          <div className="accessory-card__meta">
            <div className="accessory-card__price accessory-price">
              ${accessory.price || 0}
            </div>

          </div>
        </div>

        <div className="accessory-card__check" onClick={e => e.stopPropagation()}>
          <FormControlLabel
            control={
              <Checkbox
                {...getLegacyBomControlProps(legacyCheckboxIcons)}
                id={`accessory_${accessory.number}`}
                name="accessory_checkboxes[]"
                value={accessory.number}
                checked={isSelected}
                onChange={(event) => this.toggleAccessory(event.target.checked)}
                disabled={disable}
                size="small"
                sx={legacyCheckboxIcons ? undefined : {
                  color: '#9AA4AE',
                  padding: '4px',
                  '&.Mui-checked': {
                    color: '#0086BF',
                  },
                }}
              />
            }
            label=""
          />
        </div>

        <div className="accessory-card__description text">
          {description}
        </div>
      </div>
    );
  }
}
